import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import './input-search.scss';

const InputSearch = ({
  className, placeholder, value, onChange, onReset, loading,
}) => {
  const classNameInput = classNames('input-search', className);

  return (
    <div className="input-search__container">
      <input
        className={classNameInput}
        placeholder={placeholder}
        onChange={onChange}
        value={value}
      />
      <svg
        className="input-search__search-icon"
        width="20"
        height="20"
        viewBox="0 0 20 20"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M7.93206 13.0128C6.50899 13.0128 5.30387 12.5192 4.31671 11.532C3.32953 10.5449 2.83594 9.33974 2.83594 7.91667C2.83594 6.4936 3.32953 5.28847 4.31671 4.30129C5.30387 3.31412 6.50899 2.82054 7.93206 2.82054C9.35513 2.82054 10.5603 3.31412 11.5474 4.30129C12.5346 5.28847 13.0282 6.4936 13.0282 7.91667C13.0282 8.51175 12.9283 9.08013 12.7285 9.62179C12.5287 10.1635 12.2622 10.6346 11.9288 11.0352L16.7237 15.8301C16.8391 15.9455 16.8981 16.0905 16.9008 16.2652C16.9035 16.4399 16.8445 16.5876 16.7237 16.7083C16.603 16.829 16.4566 16.8894 16.2846 16.8894C16.1126 16.8894 15.9663 16.829 15.8455 16.7083L11.0506 11.9134C10.634 12.2575 10.1548 12.5267 9.61315 12.7211C9.07148 12.9156 8.51112 13.0128 7.93206 13.0128ZM7.93206 11.7628C9.00578 11.7628 9.91524 11.3902 10.6604 10.645C11.4056 9.89985 11.7782 8.99039 11.7782 7.91667C11.7782 6.84294 11.4056 5.93349 10.6604 5.18829C9.91524 4.4431 9.00578 4.0705 7.93206 4.0705C6.85834 4.0705 5.94888 4.4431 5.20369 5.18829C4.45851 5.93349 4.08592 6.84294 4.08592 7.91667C4.08592 8.99039 4.45851 9.89985 5.20369 10.645C5.94888 11.3902 6.85834 11.7628 7.93206 11.7628Z"
          fill="black"
          fillOpacity="0.9"
        />
        <path
          d="M11.9192 11.0273L11.9119 11.036L11.92 11.0441L16.7149 15.839C16.8278 15.9519 16.8857 16.0937 16.8883 16.2654C16.8909 16.4368 16.8332 16.5812 16.7149 16.6995C16.5965 16.8178 16.4533 16.8769 16.2846 16.8769C16.1159 16.8769 15.9727 16.8178 15.8544 16.6995L11.0595 11.9046L11.0514 11.8966L11.0427 11.9038C10.6272 12.2468 10.1493 12.5154 9.60892 12.7094C9.06862 12.9033 8.50969 13.0003 7.93206 13.0003C6.51224 13.0003 5.31032 12.508 4.32555 11.5232C3.34076 10.5384 2.84844 9.33649 2.84844 7.91667C2.84844 6.49684 3.34076 5.29492 4.32555 4.31013C5.31032 3.32536 6.51224 2.83304 7.93206 2.83304C9.35189 2.83304 10.5538 3.32536 11.5386 4.31013C12.5234 5.29492 13.0157 6.49684 13.0157 7.91667C13.0157 8.51032 12.9161 9.07723 12.7168 9.61747C12.5174 10.1579 12.2516 10.6278 11.9192 11.0273ZM7.93206 11.7753C9.00903 11.7753 9.92169 11.4015 10.6693 10.6539C11.4169 9.90629 11.7907 8.99363 11.7907 7.91667C11.7907 6.8397 11.4169 5.92704 10.6693 5.17945C9.92169 4.43187 9.00903 4.058 7.93206 4.058C6.85509 4.058 5.94244 4.43187 5.19485 5.17945C4.44727 5.92704 4.07342 6.8397 4.07342 7.91667C4.07342 8.99363 4.44727 9.90629 5.19485 10.6539C5.94244 11.4015 6.85509 11.7753 7.93206 11.7753Z"
          stroke="black"
          strokeOpacity="0.6"
          strokeWidth="0.025"
        />
      </svg>
      {!loading && !!value && (
      <svg
        onClick={onReset}
        className="input-search__delete-icon"
        width="20"
        height="20"
        viewBox="0 0 20 20"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M10.0006 10.8782L12.5615 13.4391C12.6769 13.5544 12.822 13.6135 12.9966 13.6161C13.1713 13.6188 13.319 13.5598 13.4397 13.4391C13.5605 13.3183 13.6208 13.172 13.6208 13C13.6208 12.828 13.5605 12.6816 13.4397 12.5609L10.8788 9.99997L13.4397 7.43906C13.5551 7.32368 13.6141 7.17866 13.6168 7.00397C13.6195 6.82931 13.5605 6.68161 13.4397 6.56089C13.319 6.44016 13.1726 6.37979 13.0006 6.37979C12.8286 6.37979 12.6823 6.44016 12.5615 6.56089L10.0006 9.12179L7.43971 6.56089C7.32434 6.4455 7.17931 6.38648 7.00463 6.38381C6.82996 6.38113 6.68227 6.44016 6.56155 6.56089C6.44081 6.68161 6.38044 6.82797 6.38044 6.99997C6.38044 7.17197 6.44081 7.31834 6.56155 7.43906L9.12244 9.99997L6.56155 12.5609C6.44616 12.6763 6.38713 12.8213 6.38446 12.996C6.38178 13.1706 6.44081 13.3183 6.56155 13.4391C6.68227 13.5598 6.82863 13.6202 7.00063 13.6202C7.17263 13.6202 7.31899 13.5598 7.43971 13.4391L10.0006 10.8782ZM10.002 17.9166C8.90708 17.9166 7.87789 17.7088 6.91444 17.2933C5.95098 16.8777 5.11292 16.3138 4.40023 15.6014C3.68754 14.889 3.12332 14.0513 2.70759 13.0883C2.29185 12.1253 2.08398 11.0963 2.08398 10.0014C2.08398 8.90643 2.29176 7.87723 2.70732 6.91379C3.12287 5.95033 3.68683 5.11226 4.39919 4.39958C5.11157 3.68688 5.94927 3.12267 6.9123 2.70693C7.87531 2.2912 8.90429 2.08333 9.99924 2.08333C11.0942 2.08333 12.1234 2.29111 13.0868 2.70666C14.0503 3.12222 14.8883 3.68618 15.601 4.39854C16.3137 5.11091 16.8779 5.94861 17.2937 6.91164C17.7094 7.87466 17.9173 8.90363 17.9173 9.99858C17.9173 11.0935 17.7095 12.1227 17.2939 13.0862C16.8784 14.0496 16.3144 14.8877 15.6021 15.6004C14.8897 16.3131 14.052 16.8773 13.089 17.293C12.126 17.7088 11.097 17.9166 10.002 17.9166ZM10.0006 16.6666C11.8617 16.6666 13.4381 16.0208 14.7298 14.7291C16.0215 13.4375 16.6673 11.8611 16.6673 9.99997C16.6673 8.13886 16.0215 6.56247 14.7298 5.27081C13.4381 3.97914 11.8617 3.33331 10.0006 3.33331C8.13952 3.33331 6.56313 3.97914 5.27146 5.27081C3.9798 6.56247 3.33396 8.13886 3.33396 9.99997C3.33396 11.8611 3.9798 13.4375 5.27146 14.7291C6.56313 16.0208 8.13952 16.6666 10.0006 16.6666Z"
          fill="black"
          fillOpacity="0.9"
        />
      </svg>
      )}
      {loading && (
      <i className="fa fa-spinner fa-pulse fa-2x input-search__delete-icon" />
      )}
    </div>
  );
};

InputSearch.propTypes = {
  value: PropTypes.string,
  placeholder: PropTypes.string,
  onChange: PropTypes.func.isRequired,
  onReset: PropTypes.func.isRequired,
  loading: PropTypes.bool.isRequired,
  className: PropTypes.string,
};

InputSearch.defaultProps = {
  value: undefined,
  placeholder: undefined,
  className: undefined,
};

export default InputSearch;
